/** JWT expiry helpers for proactive session refresh. */

export function getTokenExpiryMs(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;
    const payload = JSON.parse(
      atob(segment.replace(/-/g, '+').replace(/_/g, '/'))
    );
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/** True when access token is expired or within skewMs of expiry. */
export function isAccessTokenExpiringSoon(token, skewMs = 10 * 60 * 1000) {
  const exp = getTokenExpiryMs(token);
  if (!exp) return true;
  return Date.now() >= exp - skewMs;
}

export function isAccessTokenExpired(token, skewMs = 30 * 1000) {
  const exp = getTokenExpiryMs(token);
  if (!exp) return true;
  return Date.now() >= exp - skewMs;
}

export function shouldRefreshAccessToken(access) {
  if (!access) return true;
  return isAccessTokenExpiringSoon(access);
}
